<template>
  <div class="bankcardlist">
    <BankCard ref="BankCard" @done="refresh"/>
    <DelConfirm ref="DelConfirm" @del="realdel"/>
    <div class="addcard" @click="modalShow('new')">
      <i></i>
      <span>{{$t('btn.b60')}}</span>
    </div>
    <div class="banklist">
      <Datatable
        ref="datatable"
        v-slot="{item}"
        :th="[$t('label.w27'),$t('label.w28'),$t('label.w29'),$t('label.w19')]"
        url="/Member/RZJFund/BankCardList"
        :tip="$t('msg.m121')"
      >
        <tr>
          <td class="td1">
            <p>{{item.BankName}}</p>
            <p>{{item.BranchName}}</p>
          </td>
          <td class="td2">{{item.CardNumber}}</td>
          <td class="td3">{{item.CreatedAt}}</td>
          <td class="td4">
            <Button @click="del(item.Id)">{{$t('btn.b25')}}</Button>
            <Button @click="edit(item.Id)">{{$t('btn.b26')}}</Button>
          </td>
        </tr>
      </Datatable>
    </div>
  </div>
</template>

<script>
import Datatable from "@/components/datatable";
import BankCard from "./modal/bankCard";
import DelConfirm from "@/components/delConfirm";
export default {
  components: { Datatable, BankCard ,DelConfirm},
  data() {
    return {};
  },
  methods: {
    modalShow(v) {
      if (v == "new") {
        this.$refs.BankCard.modal = true;
      }
    },
    refresh() {
      this.$refs.datatable.refresh();
    },
    edit(id) {
      this.$refs.BankCard.load(id);
    },
    del(id) {
      this.$refs.DelConfirm.id = id;
      this.$refs.DelConfirm.text = this.$t('msg.m23');
      this.$refs.DelConfirm.modal = true;
    },
    realdel(id) {
      this.$axios
        .post("/Member/RZJFund/DeleteBankCard", { bankCardId: id })
        .then(res => {
          if (res.err) return res.throw();
          this.$Message.success(this.$t('msg.m24'));
          this.$Modal.remove();
          this.refresh();
        });
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.addcard {
  margin-bottom: 10px;
  height: 20px;
  display: flex;
  justify-content: flex-end;
  cursor: pointer;
  i {
    width: 20px;
    height: 20px;
    display: inline-block;
    background: url("../../assets/public_navadd.png") no-repeat;
    background-size: cover;
    margin-right: 10px;
  }
  span {
    display: inline-block;
    width: 70px;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #5e8ffc;
  }
}
.banklist {
  td {
    padding: 20px 0;
    height: 80px;
  }
  .td1 {
    text-align: left;
    padding-left: 30px;
    width: 20%;
    p:first-child {
      height: 22px;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      line-height: 22px;
      margin-bottom: 4px;
    }
    p:last-child {
      height: 17px;
      font-size: 12px;
      color: rgba(123, 123, 124, 1);
      line-height: 17px;
    }
  }
  .td2 {
    width: 35%;
    font-size: 16px;
    font-family: DIN-Medium;
    color: #333;
    line-height: 29px;
  }
  .td3 {
    width: 20%;
    font-size: 16px;
    color: #333;
    line-height: 22px;
  }
  .td4 {
    width: 25%;
    button {
      margin: 0 10px;
      display: inline-block;
      height: 32px;
      line-height: 29px;
      color: #7b7b7c;
      font-size: 14px;
      border-radius: 6px;
      border: 1px solid rgba(151, 151, 151, 1);
    }
  }
}
</style>
